'use client';

import { getOptimizelyClient } from '../utils';
import invariant from 'tiny-invariant';
import { useEffect } from 'react';
import Cookies from 'js-cookie';

export function useOptimizely(flag: string) {
    const optimizely = getOptimizelyClient();

    useEffect(() => {
        const userId = Cookies.get('x-petm-visitor-id');
        invariant(userId, 'User id must be set');

        optimizely?.createUserContext(userId)?.decide(flag);
    }, [optimizely]);

    return optimizely;
}
